var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-card",
        { attrs: { shadow: "hover" } },
        [
          _c("app-divider", {
            staticClass: "margin-bottom",
            attrs: {
              label: "Informações para emissão do DAR: ",
              addMarginTop: false
            }
          }),
          _c(
            "div",
            { staticClass: "center" },
            [
              _c(
                "el-col",
                { staticClass: "flex", attrs: { span: 8 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "Prestação (PMT):",
                      content: _vm.parcela.numero,
                      contentAlignRight: true
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label: "Quantidade de DARs emitidos:",
                      content: "0",
                      contentAlignRight: true
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label: "Tipo de pagamento:",
                      content: "À prazo",
                      contentAlignRight: true
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label: "Situação de VTN:",
                      content: "Em aberto",
                      toolTip: "left-end",
                      contentAlignRight: true
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label: "Data de Vencimento:",
                      content: _vm.parcela.dataVencimentoFormatada,
                      toolTip: "left-end",
                      contentAlignRight: true
                    }
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { staticClass: "flex", attrs: { span: 8 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "Valor inicial da Prestação (PMT):",
                      content: _vm.parcela.valorFormatado,
                      contentAlignRight: true
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label: "Total de Correção anual:",
                      content: _vm.parcela.correcaoFormatada,
                      contentAlignRight: true
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label: "Total de Juros:",
                      content: _vm.parcela.jurosFormatado,
                      contentAlignRight: true
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label: "Amortização:",
                      content: _vm.parcela.amortizacaoFormatada,
                      contentAlignRight: true
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label: "Valor total do DAR:",
                      content: _vm.parcela.valorFormatado,
                      contentAlignRight: true
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0d3868c0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d3868c0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/vtn/components/InformacoesDar.vue
// module id = null
// module chunks = 